import { render, staticRenderFns } from "./CheckManage.vue?vue&type=template&id=09af532e"
import script from "./CheckManage.vue?vue&type=script&lang=js"
export * from "./CheckManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports